export const DATA_TYPES = {
  TEXT: 'text',
  DATE: 'date',
  INTEGER: 'integer',
  FLOAT: 'float',
};

export { default as TextField } from './TextField';
export { default as DateField } from './DateField';
export { default as IntegerField } from './IntegerField';
export { default as FloatField } from './FloatField';
export { default as FormulaField } from './FormulaField';
